import {
    FETCH_ALL_FEATURE_SUCCESS, EDIT_FEATURE, UPDATE_FEATURE_SUCCESS, CREATE_FEATURE_SUCCESS, DELETE_FEATURE_SUCCESS, SET_FEATURE, SET_ROLE
} from "constants/features.constants";

const INIT_STATE = {
    features: [],
    feature: {
        id: 0,
        name: '',
        feature_type_id: 0,
        ids: [],
        video_consult_limit: 0,
        video_specialities: [],
        video_limit_condition_period: 0,
        chat_limit_needed: false,
        duration_before_consult: 0,
        duration_after_consult: 0,
        translator_second_lang: 0,
        translator_first_lang: 0
    },
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SET_ROLE: {
            let c = Object.assign({}, state.feature);
            let s = Boolean(action.value)

            var str = "";
            if (c.role_ids !== undefined) {
                str = c.role_ids;
            }

            if (s) {
                if (str === "") {
                    str = "" + action.key;
                } else {
                    str = str + "," + action.key;
                }
            } else {
                str = c.role_ids.replace(new RegExp(action.key + ',?'), '');
            }
            c.role_ids = str
            return {
                ...state,
                feature: c
            }
        }
        //set feature
        case SET_FEATURE: {
            let c = Object.assign({}, state.feature);
            c[action.key] = action.value
            return {
                ...state,
                feature: c
            }
        }
        case FETCH_ALL_FEATURE_SUCCESS: {
            return {
                ...state,
                features: action.payload.data,
                pagination: action.payload.page
            }
        }

        case UPDATE_FEATURE_SUCCESS: {
            let foundIndex = state.features.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.features);
            let o = action.payload.data
            all[foundIndex] = o
            return {
                ...state,
                features: all,
                feature: o,
            }
        }

        case CREATE_FEATURE_SUCCESS: {
            let all = Object.assign([], state.features);
            all.push(action.payload.data)
            return {
                ...state,
                features: all,
                feature: INIT_STATE.feature
            }
        }

        case DELETE_FEATURE_SUCCESS: {
            let all = Object.assign([], state.features);
            let newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                features: newArray,
            }
        }

        case EDIT_FEATURE: {
            let u = state.features.find(c => c.id === action.payload)
            let o = Object.assign({}, u)

            o.feature_type_id = o.feature_type.id
            o.ids = []
            u.selected_sub_features.forEach(function (x) {
                o.ids.push(x.sub_feature.id)
                o = Object.assign(o, x.option)
            })
            
            o.video_specialities = [1]

            return {
                ...state,
                feature: o
            }
        }




        default:
            return state;
    }
}